import React from "react";
import { Separator } from "@/components/ui/separator";
export default function TermsOverview() {
  return <section id="terms-overview" className="relative flex min-h-[50vh] flex-col items-center justify-center overflow-hidden bg-primary py-24 text-center md:py-32">
      {}
      <div className="pointer-events-none absolute inset-0 opacity-10 bg-[linear-gradient(to_right,rgba(255,255,255,0.1)_1px,transparent_1px),linear-gradient(to_bottom,rgba(255,255,255,0.1)_1px,transparent_1px)] bg-[size:40px_40px]" />

      <div className="container relative z-10 mx-auto flex flex-col items-center px-4 md:px-6">
        <h1 className="mb-8 font-serif text-4xl font-bold leading-tight tracking-normal text-primary-foreground md:text-[4rem]">
          Terms of Service
        </h1>

        <Separator className="mb-8 h-[2px] w-[80px] bg-ring" orientation="horizontal" />

        <p className="mx-auto max-w-[700px] font-sans text-base text-primary-foreground/70 md:text-lg">
          Venchandlers Nexus connects vessels with independent suppliers and
          maritime service providers, facilitates RFQ coordination, and does not
          transport cargo, operate warehouses, or guarantee delivery times, cargo
          handling, or logistics operations performed by third parties.
        </p>
      </div>
    </section>;
}